import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISitesAndTenantsInfo } from '../types/ISitesAndTenantsInfo';

export interface IGetSitesAndTenantsAcrossAllPodsResult extends ISitesAndTenantsInfo {
}

export class GetSitesAndTenantsAcrossAllPodsRequest extends Request<{}, IGetSitesAndTenantsAcrossAllPodsResult> {
  constructor() {
    super('getSitesAndTenantsAcrossAllPods', {});
  }
}
